/* HP V2 hero video modal. Self-contained: no shared selectors with the Gallery
   lightbox, no library. The YouTube iframe is only built on first open, so the
   homepage ships zero third-party video weight until a customer asks for it. */
(function () {
  var dlg = document.querySelector('[data-hpv-dialog]');
  var openBtns = document.querySelectorAll('[data-hpv-open]');
  if (!dlg || !openBtns.length) return;

  // The theme's <main> is its own stacking context below the header, so a fixed
  // child cannot escape it. Move the dialog to <body> once, at init.
  if (dlg.parentElement !== document.body) document.body.appendChild(dlg);

  var frame = dlg.querySelector('[data-hpv-frame]');
  var closeBtn = dlg.querySelector('.hp-video__close');
  var videoId = dlg.getAttribute('data-video-id');
  var videoTitle = dlg.getAttribute('data-video-title') || 'Application video';
  var lastFocused = null;

  function open(trigger) {
    lastFocused = trigger || document.activeElement;

    if (!frame.querySelector('iframe')) {
      var f = document.createElement('iframe');
      f.src =
        'https://www.youtube-nocookie.com/embed/' +
        encodeURIComponent(videoId) +
        '?autoplay=1&rel=0&playsinline=1';
      f.title = videoTitle;
      f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      f.allowFullscreen = true;
      f.setAttribute('frameborder', '0');
      frame.appendChild(f);
    }

    dlg.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    dlg.hidden = true;
    document.documentElement.style.overflow = '';
    frame.innerHTML = ''; // stops playback rather than leaving audio running
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  Array.prototype.forEach.call(openBtns, function (btn) {
    btn.addEventListener('click', function () { open(btn); });
  });

  Array.prototype.forEach.call(dlg.querySelectorAll('[data-hpv-close]'), function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (dlg.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = dlg.querySelectorAll('button, a[href], iframe');
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
